module.exports = __webpack_public_path__ + "fonts/e8869b52eb5ca9da7486053228416c0d.svg";